class SmoothScroll {
    constructor() {
        this.initListeners();
    }

    initListeners() {
        const asSendResume = document.querySelectorAll('.js-send-resume-a, .js-send-resume');
        asSendResume.forEach((a) => {
            a.addEventListener('click', function (event) {
                event.preventDefault();

                const y = document.querySelector('.js-form-section').getBoundingClientRect().top + window.scrollY;
                window.scroll({
                    top: y,
                    behavior: 'smooth'
                });
            });
        });
    }
}

const smoothScroll = new SmoothScroll();
